import UnsubscribeLandingView from './UnsubscribeLandingView';
export default { UnsubscribeLandingView };
